import { AXIOS_INSTANCE_CUSTOMER_ORDERS } from 'utilities/db';
import { useQuery } from 'react-query';

// Utility function to build query string from filters
export const buildOrderQueryString = (filters) => {
  // Convert filters object to array of key-value pairs and filter out undefined values
  return Object.entries(filters)
    .filter(
      ([_, value]) => value !== undefined && value !== null && value !== ""
    )
    .map(([key, value]) => {
      // Handle special case for customerName which needs encoding
      if (key === "customerName") {
        return `${key}=${encodeURIComponent(value)}`;
      }
      return `${key}=${value}`;
    })
    .join("&");
};

// export const useFetchOrdersHook = (keyName = 'orders', brandId, branchId, fromDate, toDate) => {
//   const { data, error, isFetching, isLoading, refetch } = useQuery(
//     [keyName, brandId, branchId, fromDate, toDate],
//     () => getOrdersByBranch(brandId, branchId, fromDate, toDate)
//   );

//   return {
//     ordersData: data,
//     ordersError: error,
//     ordersFetching: isFetching,
//     ordersLoading: isLoading,
//     ordersRefetch: refetch
//   };
// };
// const getOrdersByBranch = async (brandId, branchId, fromDate, toDate) => {
//   let result = await AXIOS_INSTANCE_CUSTOMER_ORDERS.get(`/orders/list?brandId=${brandId}&branchId=${branchId}&from=${fromDate}&to=${toDate}`);
//   return result?.data;
// };

export const useFetchOrdersHook = (
  keyName = 'orders',
  brandId,
  branchId,
  fromDate,
  toDate,
  filters = {}
) => {
  const queryStr = buildOrderQueryString(filters);

  const { data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, brandId, fromDate, toDate, queryStr],
    () => getOrdersByBranch(brandId, branchId, fromDate, toDate, queryStr)
  );

  return {
    ordersData: data,
    ordersError: error,
    ordersFetching: isFetching,
    ordersLoading: isLoading,
    ordersRefetch: refetch,
  };
};

const getOrdersByBranch = async (
  brandId,
  branchId,
  fromDate,
  toDate,
  queryStr
) => {
  let result = await AXIOS_INSTANCE_CUSTOMER_ORDERS.get(
    `/orders/list?brandId=${brandId}&branchId=${branchId}&from=${fromDate}&to=${toDate}&${queryStr}`
  );
  return result?.data;
};
